import styled from 'styled-components'

const WyborStrukturyRowStyle = styled.div`
  .row {
    grid-area: main;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 160px 112px 112px;
    color: #fff;
    border-radius: 3px;
    margin-bottom: 4px;
    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
    background: ${props => props.theme.surface};

    :hover {
      background: ${props => props.theme.black4onBlack4};
      cursor: pointer;
    }

    :active {
      background: ${props => props.theme.black16};
    }

    :hover .focusIndicator {
      background: ${props => props.theme.primary500};
    }
  }

  .version {
    display: grid;
    padding: 18px 0;
  }

  .variant {
    display: grid;
    padding: 18px 0;
  }

  .code {
    display: grid;
    padding: 18px 0;
  }

  .focusIndicator {
    width: 5px;
    height: 72px;
    margin: 0;
    border-radius: 3px 0 0 3px;
  }

  .tloStruktury {
    margin: 0;
    width: 67px;
    height: 72px;
  }

  .nazwaStruktury {
    display: flex;
  }

  .logoStruktury {
    margin: 12px 12px 12px 7px;
    border-radius: 50%;
    display: grid;
    justify-content: center;
    width: 48px;
    height: 48px;
  }

  .opisStruktury {
    padding: 12px 16px;
  }

  .opisStruktury h4 {
    color: ${props => props.theme.black87};
  }

  .opisStruktury h5 {
    color: ${props => props.theme.black60};
  }

  h1.SprFinJednostkaInnaWZlotych,
  div.SprFinJednostkaInnaWTysiacach {
    background: ${props => props.theme.ticket_IN_dark};
  }
  h1.SprFinJednostkaMalaWZlotych,
  div.SprFinJednostkaMalaWTysiacach {
    background: ${props => props.theme.ticket_MA_dark};
  }
  h1.SprFinJednostkaMikroWZlotych,
  div.SprFinJednostkaMikroWTysiacach {
    background: ${props => props.theme.ticket_MI_dark};
  }
  h1.SprFinOpWZlotych,
  div.SprFinOpWTysiacach {
    background: ${props => props.theme.ticket_OP_dark};
  }
  h1.SprFinSkonsolidowanaJednostkaInnaWZlotych,
  div.SprFinSkonsolidowanaJednostkaInnaWTysiacach {
    background: ${props => props.theme.ticket_SIN_dark};
  }
  h1.SprFinDomMaklerskiWZlotych,
  div.SprFinDomMaklerskiWTysiacach {
    background: ${props => props.theme.ticket_DM_dark};
  }

  div.SprFinJednostkaInnaWZlotych,
  h1.SprFinJednostkaInnaWTysiacach {
    background: ${props => props.theme.ticket_IN_light};
  }
  div.SprFinJednostkaMalaWZlotych,
  h1.SprFinJednostkaMalaWTysiacach {
    background: ${props => props.theme.ticket_MA_light};
  }
  div.SprFinJednostkaMikroWZlotych,
  h1.SprFinJednostkaMikroWTysiacach {
    background: ${props => props.theme.ticket_MI_light};
  }
  div.SprFinOpWZlotych,
  h1.SprFinOpWTysiacach {
    background: ${props => props.theme.ticket_OP_light};
  }
  div.SprFinSkonsolidowanaJednostkaInnaWZlotych,
  h1.SprFinSkonsolidowanaJednostkaInnaWTysiacach {
    background: ${props => props.theme.ticket_SIN_light};
  }
  div.SprFinDomMaklerskiWZlotych,
  h1.SprFinDomMaklerskiWTysiacach {
    background: ${props => props.theme.ticket_DM_light};
  }

  h2 {
    font-family: 'Ubuntu-Medium';
    font-weight: 500;
    font-size: 24px;
    letter-spacing: 0.2px;
    line-height: 2;
    margin: 0;
  }
  h4 {
    font-family: 'Ubuntu';
    font-weight: normal;
    font-size: 20px;
    letter-spacing: 0.2px;
    margin: 0;
  }
  h5 {
    font-family: 'Ubuntu';
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.3px;
    color: #fff;
    margin: 8px 0 0 0;
  }
`

export default WyborStrukturyRowStyle
